function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "book");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.194 25.419h23.987v-25.419h-24.053c-2.215 0.008-4.008 1.801-4.015 4.016v23.406c0 0.010 0 0.020 0 0.030 0 2.343 1.838 4.322 4.016 4.322h24.051v-2.119h-24.053c-0.993 0-1.897-1.051-1.897-2.204 0-0.002 0-0.005 0-0.008 0-1.097 0.872-1.99 1.961-2.025l0.003-0zM23.298 2.14v11.44l-3.206-2.813-3.151 2.797v-11.424zM14.823 2.118v14.299h2.094l3.182-2.823 3.216 2.823h2.096v-14.299h2.648v21.183h-19.586l-0.005-21.183zM6.128 2.118h0.222l0.005 21.183h-0.161c-0.722 0-1.399 0.193-1.981 0.531l0.019-0.010v-19.792c0-0.002 0-0.004 0-0.005 0-1.050 0.848-1.902 1.896-1.909h0.001z"
});

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.afba4d65.svg";
export { ForwardRef as ReactComponent };